import { Pipe, PipeTransform } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { CT } from "@shared/services/code-table/code-table.model";
import { ClickarUtilsService } from "@shared/services/utils/clickar-utils.service";

@Pipe({
	name: "clkBizCT",
	standalone: false
})
export class CodetablePipe implements PipeTransform {
	constructor(
		private utils: ClickarUtilsService,
		private translate: TranslateService
	) { }
	// TODO: su auction-details, quando si cambia la lingua, lo stato dei lotti rimane della lingua precedente fino al refresh della pagina
	transform = (value: any, codeTable: string, market?: string, splitter: string = ";", separator: string = ", "): any =>
		this.utils.isEmpty(value) ? "" : ([].concat(String(value).split(splitter)).map(v =>
			this.translate.instant([market ?? this.translate.getCurrentLang().slice(0, 2).toUpperCase(), CT[CT[codeTable]], v].join("."))
		).join(separator));
}